// Tabs.js
import React, { useEffect, useState } from "react";

const Tabs = ({ defaultTab, tabs, onChange }: any) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    // Update active tab when defaultTab changes
    setActiveTab(parseInt(defaultTab));
  }, [defaultTab]);

  const handleTabChange = (tabId: number, tabLabel: string) => {
    setActiveTab(tabId);
    // Call the onChange function provided by the parent component
    if (onChange) {
      onChange(tabId, tabLabel);
    }
  };

  return (
    <div className="flex tab-rounded">
      {tabs.map((tab: any) => (
        <div
          key={tab.id}
          className={`w-full ${
            activeTab === tab.id ? "bg-[#f9fafb] text-[#1E0AF5] " : "bg-white text-[#344054] "
          } text-sm px-4 py-3 border border-[#D0D5DD] cursor-pointer flex items-center justify-center font-interSemiBold hover:bg-[#f9fafb] `}
          onClick={() => {
            handleTabChange(tab.id, tab.label);
          }}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
